<template>
  <VueAwesomeSideBar 
    v-model:dark="dark" 
    v-model:miniMenu="miniMenu" 
    v-model:collapsed="collapsed"
    v-model:BottomMiniMenuBtn="bottomMiniMenuBtn" 
    v-model:rtl="rtl" v-model:menuType="menuType"
    v-model:childrenOpenAnimation="childrenOpenAnimation"
    :closeOnClickOutSide="$store.getters.isMobile ? closeOnClickOutSide : false"
    :overLayerOnOpen="$store.getters.isMobile ? overLayerOnOpen : false"
    :widthMiniMenu="widthMiniMenu"
    :width="width"
    :menu="menu" 
    vueRouterEnabel v-if="$store.getters.getLoggedIn === true"
    >
    <template #header>
      <div class="topContainer p-1 pt-3 position-relative text-center align-items-center">
        <img src="../assets/logo_sidebar.png" alt="Logo CPAPS" :class="miniMenu ? 'img-logo' : 'img-mini'"
          id="sidebarLogoHome" @click="getHomeView()">
        <i v-if="!miniMenu" class="siscont icon_back position-absolute start-0 top-0 ms-3"
          :class="miniMenu ? 'mt-3' : 'mt-5'" @click="triggerBottomBtnIcon" id="sidebarToggleButton"></i>
        <div class="pb-2" v-if="!miniMenu"></div>
        <div class="mt-3">
          <i v-if="miniMenu" class="siscont icon_menu" @click="triggerBottomBtnIcon" id="sidebarOpenButton"></i>
        </div>
      </div>
    </template>
  </VueAwesomeSideBar>
</template>

<script setup>
import router from '@/router';
import { ref, reactive, watch } from 'vue'
import { useStore } from "vuex";

const collapsed = ref(false)
const miniMenu = ref(true)
const bottomMiniMenuBtn = ref(true)
const paddingTop = ref('50px')
const rtl = ref(false)
const menuType = ref('fully')
const childrenOpenAnimation = ref(true)
const closeOnClickOutSide = ref(true)
const overLayerOnOpen = ref(true)
const dark = ref(true)
const widthMiniMenu = ref('54px')
const width = ref('230px')

const triggerBottomBtnIcon = () => {
  const btn = document.querySelector('.bottomBtnIcon')
  if (btn) {
    btn.click()
  } else {
    console.warn('Botão .bottomBtnIcon não encontrado.')
  }
}

const getHomeView = () => {
  router.push({ name: 'home' });
};

const store = useStore();

let records = reactive([])
let recordsReports = reactive([])
let recordsInventory = reactive([])
let recordsRentals = reactive([])
let recordsConference = reactive([])
let recordsInventoryLogistic = reactive([])
let recordsScrums = reactive([])
let recordsManage = reactive([])
let recordsOrders = reactive([])
let recordsStockroom = reactive([])
let recordsLogisticConference = reactive([])
let recordsInventoryAnalysis = reactive([])
let recordsLocationproducts = reactive([])
let recordsScrumsManage = reactive([])
let recordsBillingManage = reactive([])
let recordsHelp = reactive([])
let recordsRentalDemandReport = reactive([])
let recordsExchange = reactive([])
let serviceOrdersReport = reactive([])
let menu = reactive([])

menu.push(
  {
    name: 'Cadastro',
    icon: { text: '', class: 'siscont icon_new_register' },
    children: records
  },
)

menu.push(
  {
    name: 'Vendas',
    icon: { text: '', class: 'siscont icon_new_order' },
    children: recordsOrders
  }
)

if (store.getters.checkPermissionsUser('list-rentals')) {
  menu.push(
    {
      name: 'Locações',
      icon: { text: '', class: 'siscont icon_rental_goal' },
      children: recordsRentals
    },
  )
}

if (store.getters.checkPermissionsUser('rental-stock-request-list')) {
  menu.push(
    {
      name: 'Análise de Giro',
      icon: { text: '', class: 'siscont icon_update' },
      children: recordsRentalDemandReport
    },
  )
}

if (store.getters.checkPermissionsUser('list-service-orders')) {
  let serviceOrderMenu = {
    name: 'Ordens de serviço',
    icon: { text: '', class: 'siscont icon_new_service_order' },
    children: [
      {
        name: 'Listagem',
        href: '/service-order',
      },
      {
        name: 'Equipamentos',
        href: '/service-order-equipment',
      },
      {
        name: 'Equipamentos - Doação',
        href: '/service-order-equipment/for-donation',
      },
    ],
  };

    if (store.getters.checkPermissionsUser('list-parts-requests')) {
      serviceOrderMenu.children.push({
        name: 'Gestão de Peças',
        href: '/service-order/parts-management',
      });
    }

    if (store.getters.checkPermissionsUser('list-typeServiceOrders')) {
      serviceOrderMenu.children.push({
        name: 'Tipos',
        href: '/type-service-order',
      });
    }

    serviceOrderMenu.children.push({
      name: 'Serviços',
      href: '/service-order/services',
    });

    serviceOrderMenu.children.push({
      name: 'Pedidos',
      href: '/service-order/requests',
    });

    if (store.getters.checkPermissionsUser('access-service-order-dashboard')) {
      serviceOrderMenu.children.push({
        name: 'Dashboard AT',
        href: '/service-order/dashboard',
      });
    }
  
    serviceOrderMenu.children.push({
      name: 'Relatórios',
      children: serviceOrdersReport
    });

    serviceOrdersReport.push({
      name: 'Relatórios OS',
      href: '/report/service-orders',
    });

    serviceOrdersReport.push({
      name: 'Relatório OS x Locação',
      href: '/service-order/report',
    });

  menu.push(serviceOrderMenu);
}

if (store.getters.checkPermissionsUser('list-exchanges')) {
  menu.push(
    {
      name: 'Trocas',
      icon: { text: '', class: 'siscont icon_exchange' },
      children: recordsExchange
    },
  )
}

if (store.getters.checkPermissionsUser('list-exchanges')) {
  if (!recordsExchange.find(e => e.href === '/exchange')) {
    recordsExchange.push(
      {
        name: 'Solicitações',
        href: '/exchange'
      }
    )
  }
}

if (store.getters.checkPermissionsUser('list-used-products')) {
  if (!recordsExchange.find(e => e.href === '/exchange/products-manage')) {
    recordsExchange.push(
      {
        name: 'Gestão de Produtos Usados',
        href: '/exchange/products-manage'
      }
    )
  }
}

if (store.getters.checkPermissionsUser('list-exchange-reasons')) {
  if (!recordsExchange.find(e => e.href === '/exchange/reasons')) {
    recordsExchange.push(
      {
        name: 'Motivos',
        href: '/exchange/reasons'
      }
    )
  }
}

if (store.getters.checkPermissionsUser('list-exchange-rejection-reasons')) {
  if (!recordsExchange.find(e => e.href === '/exchange/rejection-reasons')) {
    recordsExchange.push(
      {
        name: 'Motivos de Reprovação',
        href: '/exchange/rejection-reasons'
      }
    )
  }
}

if (store.getters.checkPermissionsUser('list-exchange-types')) {
  if (!recordsExchange.find(e => e.href === '/type-exchange')) {
    recordsExchange.push(
      {
        name: 'Tipos de Troca',
        href: '/type-exchange'
      }
    )
  }
}

if (store.getters.checkPermissionsUser('access-reverse-logistic')) {
  let correiosMenu = {
    name: 'Correios',
    icon: { text: '', class: 'siscont icon_package' },
    children: [
      {
        name: 'Logística Reversa',
        href: '/reverse-logistic',
      },
    ]
  };
  menu.push(correiosMenu);
}

menu.push(
  {
    name: 'Conferência',
    icon: { text: '', class: 'siscont icon_new_conference' },
    children: recordsConference
  }
)

menu.push({
  name: 'Inventário',
  icon: { text: '', class: 'siscont icon_new_inventory' },
  children: recordsInventory
})

if (store.getters.checkPermissionsUser('access-management-menu')) {
  menu.push(
    {
      name: 'Gerência',
      icon: { text: '', class: 'siscont icon_manage' },
      children: recordsManage
    },
  )
}

if (
  store.getters.checkPermissionsUser('list-location-products') ||
  store.getters.checkPermissionsUser('list-locations') ||
  store.getters.checkPermissionsUser('list-storages') ||
  store.getters.checkPermissionsUser('see-location-product-logs') ||
  store.getters.checkPermissionsUser('list-entrance-conferences') ||
  store.getters.checkPermissionsUser('all-logistic-conferences')
) {
  menu.push(
    {
      name: 'Logística',
      icon: { text: '', class: 'siscont icon_new_logistic' },
      children: recordsInventoryLogistic
    },
  )
}

if (store.getters.checkPermissionsUser('list-order-budgets')) {
  menu.push(
    {
      name: 'Orçamento',
      href: '/budget',
      icon: { text: '', class: 'siscont icon_new_budget' },
    },
  )
}
// list-reports
if (store.getters.checkPermissionsUser('report-orders') || store.getters.checkPermissionsUser('report-rentals') || store.getters.checkPermissionsUser('performance-report-logistic') || store.getters.checkPermissionsUser('list-report-quarters')) {
  menu.push(
    {
      name: 'Relatórios',
      icon: { text: '', class: 'siscont icon_new_report' },
      children: recordsReports
    }
  )
}

  menu.push(
      {
        name: 'Bitrix',
        icon: { text: '', class: 'siscont icon_list' },
        children: recordsScrums
      }
  )

menu.push(
  {
    name: 'Correio do Bem',
    href: '/mail',
    icon: { text: '', class: 'siscont icon_mail' },
  },
)

if (store.getters.checkPermissionsUser('acess-rental-billing-report')) {
  menu.push(
    {
      name: 'Financeiro',
      icon: { text: '', class: 'siscont icon_paid' },
      children: recordsBillingManage
    }
  )
}

menu.push({
  name: 'Ajuda',
  icon: { text: '', class: 'siscont icon_help' },
  children: recordsHelp
})

const loadMenu = async () => {
  records.length = 0
  recordsReports.length = 0
  recordsInventory.length = 0
  recordsRentals.length = 0
  recordsScrums.length = 0
  recordsLocationproducts.length = 0
  recordsLogisticConference.length = 0
  recordsManage.length = 0
  recordsOrders.length = 0
  recordsStockroom.length = 0
  recordsScrumsManage.length = 0
  recordsInventoryLogistic.length = 0
  recordsInventoryAnalysis.length = 0
  recordsHelp.length = 0
  recordsRentalDemandReport.length = 0

  if (recordsOrders.find(e => e?.href === '/order') == undefined) {
    recordsOrders.push(
      {
        name: 'Pedidos',
        href: '/order',
      }
    )
  }

  if (records.find(e => e?.href === '/customer') == undefined) {
    records.push(
      {
        name: 'Cliente',
        href: '/customer',
      }
    )
  }

  if (records.find(e => e?.href === '/product/groups') == undefined) {
    records.push(
      {
        name: 'Grupo de Produtos',
        href: '/product/groups',
      }
    )
  }

  if (records.find(e => e?.href === '/product') == undefined) {
    records.push(
      {
        name: 'Produto',
        href: '/product',
      }
    )
  }

  if (store.getters.checkPermissionsUser('performance-report-logistic')) {
    if (!recordsInventoryLogistic.find(e => e.href === '/report/logistic/performance')) {
      recordsInventoryLogistic.push(
        {
          name: 'Rel. Performance Inv. Logistica',
          href: '/report/logistic/performance',
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('inventory-logistic')) {
    if (!recordsInventoryLogistic.find(e => e.href === '/inventory/logistic')) {
      recordsInventoryLogistic.push(
        {
          name: 'Inventário',
          children: recordsInventoryAnalysis
        }
      )
    }
  }

  if (!recordsInventoryAnalysis.find(e => e.href === '/inventory/analysis')) {
    recordsInventoryAnalysis.push(
      {
        name: 'Listagens',
        href: '/inventory/logistic',
      }
    )
  }

  if (!recordsInventoryAnalysis.find(e => e.href === '/inventory/analysis')) {
    recordsInventoryAnalysis.push(
      {
        name: 'Análise de Inventário',
        href: '/inventory/analysis',
      }
    )
  }

  if (store.getters.checkPermissionsUser('list-location-products')) {
    if (recordsInventoryLogistic.find(e => e?.href === '/type-products-logistic') == undefined) {
      recordsInventoryLogistic.push(
        {
          name: 'Gerência',
          children: recordsLocationproducts
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('list-location-products')) {
    if (recordsLocationproducts.find(e => e?.href === '/type-products-logistic') == undefined) {
      recordsLocationproducts.push(
        {
          name: 'Localização de Produtos',
          href: '/type-products-logistic',
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('list-locations')) {
    if (recordsLocationproducts.find(e => e?.href === '/type-adress') == undefined) {
      recordsLocationproducts.push(
        {
          name: 'Endereçamento',
          href: '/type-adress',
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('list-storages')) {
    if (recordsLocationproducts.find(e => e?.href === '/type-storage') == undefined) {
      recordsLocationproducts.push(
        {
          name: 'Armazenamento',
          href: '/type-storage',
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('see-location-product-logs')) {
    if (recordsLocationproducts.find(e => e?.href === '/type-products-logistic/logs') == undefined) {
      recordsLocationproducts.push(
        {
          name: 'Logs',
          href: '/type-products-logistic/logs',
        }
      )
    }
  }

  if (records.find(e => e?.href === '/prescriber') == undefined) {
    records.push(
      {
        name: 'Prescritor',
        href: '/prescriber',
      }
    )
  }

  if (store.getters.checkPermissionsUser('list-users')) {
    if (!recordsManage.find(e => e.href === '/user')) {
      recordsManage.push(
        {
          name: 'Usuários',
          href: '/user',
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('list-roles')) {
    if (!recordsManage.find(e => e.href === '/role')) {
      recordsManage.push(
        {
          name: 'Grupos de acesso',
          href: '/role',
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('list-users')) {
    if (!recordsManage.find(e => e.href === '/access-query')) {
      recordsManage.push(
        {
          name: 'Permissões',
          href: '/access-query',
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('see-system-logs')) {
    if (!recordsManage.find(e => e.href === '/system/logs/views')) {
      recordsManage.push(
        {
          name: 'Logs de Sistema',
          href: '/system/logs/views',
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('see-system-logs')) {
    if (!recordsManage.find(e => e.href === '/system/logs/login')) {
      recordsManage.push(
        {
          name: 'Logs de Login',
          href: '/system/logs/login',
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('list-enterprises')) {
    if (!recordsManage.find(e => e.href === '/enterprise')) {
      recordsManage.push(
        {
          name: 'Empresas',
          href: '/enterprise',
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('list-typeOrders')) {
    if (!recordsOrders.find(e => e.href === '/type-order')) {
      recordsOrders.push(
        {
          name: 'Tipos de pedido',
          href: '/type-order',
        }
      )
    }
  }

  if (!records.find(e => e.href === '/service')) {
    records.push(
      {
        name: 'Serviços',
        href: '/service',
      }
    )
  }

  if (store.getters.checkPermissionsUser('list-typeRentals')) {
    if (!recordsRentals.find(e => e.href === '/type-rental')) {
      recordsRentals.push(
        {
          name: 'Tipos de locação',
          href: '/type-rental',
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('list-payments')) {
    if (!records.find(e => e.href === '/payment')) {
      records.push(
        {
          name: 'Forma de pagamento',
          href: '/payment',
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('list-deadlines')) {
    if (!recordsRentals.find(e => e.href === '/deadline')) {
      recordsRentals.push(
        {
          name: 'Planos',
          href: '/deadline',
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('create-goals')) {
    if (!records.find(e => e.href === '/goal')) {
      records.push(
        {
          name: 'Metas',
          href: '/goal',
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('list-analyzer')) {
    if (!records.find(e => e.href === '/analyze')) {
      records.push(
        {
          name: 'Analisadores',
          href: '/analyze',
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('list-ftes')) {
    recordsScrums.push(
      {
        name: 'Gerência',
        children: recordsScrumsManage
      }
    )
  }

  if (store.getters.checkPermissionsUser('list-sectors')) {
    if (!recordsScrumsManage.find(e => e.href === '/sectors')) {
      recordsScrumsManage.push(
        {
          name: 'Setores',
          href: '/sectors',
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('list-categories')) {
    if (!recordsScrumsManage.find(e => e.href === '/category')) {
      recordsScrumsManage.push(
        {
          name: 'Categorias',
          href: '/category',
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('list-sub-categories')) {
    if (!recordsScrumsManage.find(e => e.href === '/sub-category')) {
      recordsScrumsManage.push(
        {
          name: 'Sub-Categorias',
          href: '/sub-category',
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('list-additional_options')) {
    if (!recordsScrumsManage.find(e => e.href === '/additional-options')) {
      recordsScrumsManage.push(
        {
          name: 'Opções adicionais',
          href: '/additional-options',
        }
      )
    }
  }

  if (!recordsScrumsManage.find(e => e.href === '/fields')) {
      recordsScrumsManage.push(
      {
        name: 'Campos',
        href: '/fields',
      }
    )
  }

  if (store.getters.checkPermissionsUser('edit-task-templates')) {
    if (!recordsScrums.find(e => e.href === '/templates')) {
      recordsScrums.push(
        {
          name: 'Templates',
          href: '/templates',
        }
      )
    }
  }

  if (!recordsScrums.find(e => e.href === '/task-create/public')) {
      recordsScrums.push(
        {
          name: 'Criar Tarefa',
          href: '/task-create/public',
        }
      )
    }

  if (store.getters.checkPermissionsUser('report-orders')) {
    if (!recordsOrders.find(e => e.href === '/report/orders')) {
      recordsOrders.push(
        {
          name: 'Relatório',
          href: '/report/orders',
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('report-rentals')) {
    if (!recordsRentals.find(e => e.href === '/report/rentals')) {
      recordsRentals.push(
        {
          name: 'Relatório',
          href: '/report/rentals',
        }
      )
    }
  }

  if (!recordsReports.find(e => e.href === '/report/products')) {
    recordsReports.push(
      {
        name: 'Produtos',
        href: '/report/products',
      }
    )
  }

  if (store.getters.checkPermissionsUser('report-rentals')) {
    if (!recordsRentals.find(e => e.href === '/report/rental/prescriber')) {
      recordsRentals.push(
        {
          name: 'Rel. Locação Parc./Presc.',
          href: '/report/rental/prescriber',
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('list-report-quarter')) {
    if (!recordsInventory.find(e => e.href === '/report/inventory')) {
      recordsInventory.push(
        {
          name: 'Relatório de Divergências',
          href: '/report/inventory',
        }
      )
    }
  }

  if (recordsInventory.find(e => e?.href === '/inventory') == undefined) {
    recordsInventory.push(
      {
        name: 'Loja',
        href: '/inventory',
      }
    )
  }

  if (store.getters.checkPermissionsUser('list-single-counts')) {
    if (!recordsInventory.find(e => e.href === '/inventory/single-count')) {
      recordsInventory.push(
        {
          name: 'Contagem Avulsa',
          href: '/inventory/single-count',
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('list-tech-assist-inventorys')) {
    if (!recordsInventory.find(e => e.href === '/inventory/tech-assist')) {
      recordsInventory.push(
        {
          name: 'Assistência Técnica',
          href: '/inventory/tech-assist',
        }
      )
    }
  }

  if (!recordsRentals.find(e => e.href === '/rental')) {
    recordsRentals.unshift(
      {
        name: 'Lançamentos',
        href: '/rental',
      }
    )
  }

  if (!recordsRentals.find(e => e.href === '/rental-stock')) {
    recordsRentals.push(
      {
        name: 'Estoque',
        href: '/rental-stock',
      }
    )
  }

  if (store.getters.checkPermissionsUser('list-equipment')) {
    if (!recordsRentals.find(e => e.href === '/equipment')) {
      recordsRentals.push(
        {
          name: 'Equipamentos',
          href: '/equipment',
        }
      )
    }
  }

  if (!recordsConference.find(e => e.href === '/conference')) {
    recordsConference.push(
      {
        name: 'Loja',
        href: '/conference',
      }
    )
  }

  if (store.getters.checkPermissionsUser('all-logistic-conferences')) {
    if (!recordsInventoryLogistic.find(e => e.href === '/conference/logistic')) {
      recordsInventoryLogistic.push(
        {
          name: 'Importação',
          children: recordsLogisticConference
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('all-logistic-conferences')) {
    if (!recordsLogisticConference.find(e => e.href === '/spreadsheet')) {
      recordsLogisticConference.push(
        {
          name: 'Planilhas',
          href: '/spreadsheet',
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('all-logistic-conferences')) {
    if (!recordsLogisticConference.find(e => e.href === '/conference/logistic')) {
      recordsLogisticConference.push(
        {
          name: 'Listagem',
          href: '/conference/logistic',
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('list-entrance-conferences')) {
    if (!recordsInventoryLogistic.find(e => e.href === '/conference/entrance')) {
      recordsInventoryLogistic.push(
        {
          name: 'Entrada',
          href: '/conference/entrance'
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('list-control-hours')) {
    if (!recordsRentals.find(e => e.href === '/rental/control-hours')) {
      recordsRentals.push({
        name: 'Controle de Horas',
        href: '/rental/control-hours'
      });
    }
  }

  if (store.getters.checkPermissionsUser('list-rental-reasons')) {
    if (!recordsRentals.find(e => e.href === '/rental/report/converted')) {
      recordsRentals.push({
        name: 'Motivos',
        href: '/rental/reasons'
      });
    }
  }

  if (store.getters.checkPermissionsUser('acess-rental-conversion-report')) {
    if (!recordsRentals.find(e => e.href === '/rental/report/converted')) {
      recordsRentals.push({
        name: 'Relatório Locação Convertidas',
        href: '/rental/report/converted'
      });
    }
  }

  if (store.getters.checkPermissionsUser('acess-bidding-report')) {
    if (!recordsRentals.find(e => e.href === '/rental/report/bidding')) {
      recordsRentals.push({
        name: 'Relatório Licitação',
        href: '/rental/report/bidding'
      });
    }
  }

  if (store.getters.checkPermissionsUser('list-all-stockrooms')) {
    if (!recordsStockroom.find(e => e.href === '/stockroom')) {
      recordsStockroom.push(
        {
          name: 'Solicitações',
          href: '/stockroom',
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('list-all-stockrooms')) {
    if (!recordsStockroom.find(e => e.href === '/stockroom/products')) {
      recordsStockroom.push(
        {
          name: 'Produtos',
          href: '/stockroom/products',
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('acess-rental-billing-report')) {
    if (!recordsBillingManage.find(e => e.href === '/billing-manage')) {
      recordsBillingManage.push(
        {
          name: 'Gestão de Cobranças',
          href: '/billing-manage',
        }
      )
    }
  }

  if (!recordsHelp.find(e => e.href === '/faq')) {
    recordsHelp.push(
      {
        name: 'FAQ',
        href: '/faq',
      }
    )
  }

  if (store.getters.checkPermissionsUser('manage-tags')) {
    if (!recordsHelp.find(e => e.href === '/tag/manage')) {
      recordsHelp.push(
        {
          name: 'Gerenciar Tags',
          href: '/tag/manage',
        }
      )
    }
  }
  if (store.getters.checkPermissionsUser('rental-stock-request-list')) {
    if (!recordsRentalDemandReport.find(e => e.href === '/rental-demand-report')) {
      recordsRentalDemandReport.push(
        {
          name: 'Relatório',
          href: '/rental-demand-report',
        }
      )
    }
  }

  if (store.getters.checkPermissionsUser('rental-stock-request-list')) {
    if (!recordsRentalDemandReport.find(e => e.href === '/rental-stock-request')) {
      recordsRentalDemandReport.push(
        {
          name: 'Solicitação de Ativos',
          href: '/rental-stock-request',
        }
      )
    }
  }
};

watch(() => store.getters.getUser, async (newVal, oldVal) => {
  if (!newVal) return;
  await loadMenu();
}, { immediate: true });
</script>